import { render } from "./PreloaderComp.vue?vue&type=template&id=3d0f2aa6&scoped=true"
import script from "./PreloaderComp.vue?vue&type=script&lang=js"
export * from "./PreloaderComp.vue?vue&type=script&lang=js"

import "./PreloaderComp.vue?vue&type=style&index=0&id=3d0f2aa6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0f2aa6"]])

export default __exports__